import { render } from "./SDGPlansComponent.vue?vue&type=template&id=af814068&scoped=true"
import script from "./SDGPlansComponent.vue?vue&type=script&lang=js"
export * from "./SDGPlansComponent.vue?vue&type=script&lang=js"

import "./SDGPlansComponent.vue?vue&type=style&index=0&id=af814068&scoped=true&lang=css"

import exportComponent from "/home/runner/work/hanlin-lesson-plan/hanlin-lesson-plan/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af814068"]])

export default __exports__